export interface SearchBoxFilterProps {
  onChange: (value: string) => void;
}
function SearchBox({ onChange }: SearchBoxFilterProps) {
  return (
    <div className="input-group">
      <input
        type="text"
        className="form-control"
        placeholder="شماره موردنظرخود را پیدا کنید"
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}

export default SearchBox;
